import { render, staticRenderFns } from "./MainMenu.vue?vue&type=template&id=da082dda"
import script from "./MainMenu.vue?vue&type=script&lang=js"
export * from "./MainMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da082dda')) {
      api.createRecord('da082dda', component.options)
    } else {
      api.reload('da082dda', component.options)
    }
    module.hot.accept("./MainMenu.vue?vue&type=template&id=da082dda", function () {
      api.rerender('da082dda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/navigation/MainMenu.vue"
export default component.exports